import { Option } from '@chillibean/component-library';

export class User {
  constructor(params = {}) {
    this.id = params.id;
    this.firstName = params.firstName;
    this.lastName = params.lastName;
    this.email = params.email;
    this.uuid = params.uuid;
    this.role = params.role;
  }

  fullName() {
    if (!this.firstName && !this.lastName) return this.email;

    return `${this.firstName} ${this.lastName}`;
  }

  multiSelectParams() {
    return new Option(this.fullName(), this.id);
  }

  fullNameAndEmail() {
    return `${this.fullName()} - ${this.email}`;
  }

  findById(id) {
    return this.id === id;
  }
}
